/* Collection — infinite scroll */
(function () {
  function init() {
    const wrap = document.querySelector('[data-infinite-scroll]');
    if (!wrap) return;
    const grid = document.querySelector('.collection-grid');
    if (!grid) return;
    const btn = wrap.querySelector('[data-infinite-load]');
    const sentinel = wrap.querySelector('[data-infinite-sentinel]');

    let loading = false;

    async function loadNext() {
      if (loading) return;
      const next = wrap.getAttribute('data-next-url');
      if (!next) { finish(); return; }
      loading = true;
      wrap.setAttribute('data-loading', '');

      try {
        const res = await fetch(next, { headers: { 'Accept': 'text/html' } });
        if (!res.ok) throw new Error('Fetch failed: ' + res.status);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const nextGrid = doc.querySelector('.collection-grid');
        if (nextGrid) {
          const frag = document.createDocumentFragment();
          Array.from(nextGrid.children).forEach((node) => frag.appendChild(node));
          grid.appendChild(frag);
        }

        const nextWrap = doc.querySelector('[data-infinite-scroll]');
        if (nextWrap && nextWrap.getAttribute('data-next-url')) {
          wrap.setAttribute('data-next-url', nextWrap.getAttribute('data-next-url'));
        } else {
          wrap.removeAttribute('data-next-url');
          finish();
        }

        if (typeof window.shopifyReinitCards === 'function') {
          window.shopifyReinitCards(grid);
        }
      } catch (err) {
        console.error('[infinite-scroll]', err);
      } finally {
        loading = false;
        wrap.removeAttribute('data-loading');
      }
    }

    function finish() {
      wrap.setAttribute('data-done', '');
      if (observer) observer.disconnect();
    }

    if (btn) btn.addEventListener('click', loadNext);

    let observer = null;
    if ('IntersectionObserver' in window && sentinel) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) loadNext(); });
      }, { rootMargin: '600px 0px' });
      observer.observe(sentinel);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
